export default "__VITE_ASSET__uJ5UbBj1__"